import type {
  JsonObject,
  ValidateSentriLockDeviceResponse,
} from '@/app-package';
import axios from 'axios';

export type ValidateSentriLockDevice =
  JsonObject<ValidateSentriLockDeviceResponse>;

const validateSentrilockDevice = async (
  deviceId: string,
  listingId: string,
) => {
  const { data } = await axios.get<ValidateSentriLockDevice>(
    `/appointment/sentrilock/validate/${deviceId}?listingId=${listingId}`,
  );

  return data;
};

export default validateSentrilockDevice;
